import React from 'react';
import { useNavigate } from 'react-router-dom';

const ServiceGrid = () => {
  const navigate = useNavigate();

  return (
    <section id="servicios" className="w-full bg-white">
      {/* Título en contenedor, secciones full-bleed fuera del contenedor */}
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-16">
        <h2 className="font-serif text-5xl text-center">Tu Belleza, Nuestra Inspiración</h2>
      </div>

        <section className="group relative w-screen min-h-[600px] overflow-hidden flex items-center justify-start mb-0">
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-300 ease-out group-hover:scale-105 z-0"
          style={{
            backgroundImage:
              "url('https://disjteanovqtsuirirkt.supabase.co/storage/v1/object/public/assets/images/detalle%20y%20lugar%20012.JPG')",
          }}
        />
        <div className="z-10 bg-white/80 p-8 rounded-lg max-w-md ml-16 md:ml-24 shadow-sm">
          <h3 className="font-serif text-3xl mb-4">Salón de Belleza</h3>
          <p className="text-gray-800 mb-1">
            ⦁	Diseño de mirada: Lifting de pestañas extensiones, perfilado de cejas y visagismo. 
          
          </p>
           <p className="text-gray-800 mb-1">⦁ Manicure</p>
               <p className="text-gray-800 mb-6">⦁ Pedicure</p>
          <button 
            onClick={() => navigate('/agendamiento')}
            className="inline-block bg-primary-accent text-white px-6 py-3  hover:bg-primary-accent/90 transition-colors"
          >
            Agendar Cita
          </button>
        </div>
      </section>

{/* Separador entre Peluquería y Barbería */}
      <div className="w-full h-24 bg-primary-light flex items-center justify-center mt-0 mb-0">
        <span className="font-serif text-4xl text-primary-accent">*</span>
      </div>

      {/* Barbería: full-bleed, flex R (justify-end) */}
      <section className="group relative w-screen min-h-[600px] overflow-hidden flex items-center justify-end mb-0">
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-300 ease-out group-hover:scale-105 z-0"
          style={{
            backgroundImage:
              "url('https://disjteanovqtsuirirkt.supabase.co/storage/v1/object/public/assets/images/barberia.jpg')",
          }}
        />
        <div className="z-10 bg-white/80 p-8 rounded-lg max-w-md mr-16 md:mr-24 shadow-sm">
          <h3 className="font-serif text-3xl mb-4">Barbería</h3>
          <p className="text-gray-800 mb-6">
            Afeitado clásico, perfilado y cuidado de barba con precisión. Estilo
            impecable para quienes buscan detalle y personalidad en cada visita.
          </p>
          <button 
            onClick={() => navigate('/agendamiento')}
            className="inline-block bg-primary-accent text-white px-6 py-3  hover:bg-primary-accent/90 transition-colors"
          >
            Agendar Cita
          </button>
        </div>
      </section>

       <div className="w-full h-24 bg-primary-light flex items-center justify-center mt-0 mb-0">
        <span className="font-serif text-4xl text-primary-accent">*</span>
      </div>

         {/* Peluquería: full-bleed, flex L (justify-start) */}
      <section className="group relative w-screen min-h-[600px] overflow-hidden flex items-center justify-start mb-0">
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-300 ease-out group-hover:scale-105 z-0"
          style={{
            backgroundImage:
              "url('https://disjteanovqtsuirirkt.supabase.co/storage/v1/object/public/assets/images/detalle%20y%20lugar%20024.JPG')",
          }}
        />
        <div className="z-10 bg-white/80 p-8 rounded-lg max-w-md ml-16 md:ml-24 shadow-sm">
          <h3 className="font-serif text-3xl mb-4">Peluquería y Colorimetría</h3>
          <p className="text-gray-800 mb-6">
            Cortes, color y tratamientos diseñados para realzar tu estilo con técnica y
            cuidado profesional. Vive una experiencia personalizada para tu cabello.
          </p>
          <button 
            onClick={() => navigate('/agendamiento')}
            className="inline-block bg-primary-accent text-white px-6 py-3  hover:bg-primary-accent/90 transition-colors"
          >
            Agendar Cita
          </button>
        </div>
      </section>
    </section>
  );
};

export default ServiceGrid;